import React from "react";
import { Copy, Share2 } from "lucide-react";
import { toast } from "sonner";
import { SITE_URL } from "../lib/publicSite";

export const PublicShare = ({ route, title, testId }) => {
    const url = `${SITE_URL}/api/og/${route}`;
    const copy = async () => {
        try { await navigator.clipboard.writeText(url); toast.success("Public share link copied."); }
        catch { toast.error("Could not copy the link."); }
    };
    const share = async () => {
        if (!navigator.share) return copy();
        try { await navigator.share({ title, url }); }
        catch (error) { if (error.name !== "AbortError") toast.error("Could not open sharing."); }
    };
    return <div className="flex items-center gap-2">
        <button type="button" data-testid={`${testId}-share`} title="Share this public page" onClick={share} className="inline-flex items-center gap-1.5 rounded-full border border-black/15 px-3 py-2 text-sm text-[#4A5568] hover:text-[#E53935] hover:border-[#E53935]/40 transition-colors"><Share2 size={16} />Share</button>
        <button type="button" data-testid={`${testId}-copy`} title="Copy public share link" aria-label="Copy public share link" onClick={copy} className="p-2 rounded-full text-[#4A5568] hover:bg-[#F4F1EA] transition-colors"><Copy size={16} /></button>
    </div>;
};